<template>
    <div class="project">
        <section class="banner"> <router-link to="/"><img alt="back" title="Back" class="backArrow" width="40px" height="40px" src="../assets/img/WhiteArrow.svg" ></router-link></section>
        <section class="titleBanner">
            <div class="titleContent">
                <div class="RightBanner">
                    <h1 class="Title">Chime</h1>
                    <h2 class="subHeader">Senior Project</h2>
                    <h2 class="subHeader">Imagine RIT 2019</h2>
                </div>
                <div class="RightBanner">
                    <h2 class="subHeader">Team Size:</h2>
                    <h2 class="subHeader">4 Designers</h2>
                    <h2 class="subHeader">3 Developers</h2>
                    <h2 class="subHeader">2 Musicians</h2>
                </div>
            </div>
        </section>
        <section class="projectContent">
            <div class="videoPlayer">
                <div class="iframeWrapper">
                <iframe id="videoProject" title="Exhibit Video"  src="https://player.vimeo.com/video/442083548" width="640" height="360"
                    frameborder="0" allow="autoplay; fullscreen" allowfullscreen> Your Browser doesn't support this
                    video</iframe>
                </div>
                <p class="tagline">Filmed & Edited by Rachel Manhardt</p>
            </div>
            <div class="content">
                <div class="left chimeImg mImage"> <img alt="Chime Exhibt"  title="Chime Exhibit"  class="projectImg" src="../assets/img/Chime4.svg"></div>
                <div class="right">
                    <p class="description">Chime, a collaborative, interactive experience featured at Imagine RIT 2019, was designed to enable people to create music together without being hindered by a communication barrier. We began this project by launching a web app that allowed the community to lend their voice to this project. </p>
                </div>
                <div class="left">
                    <p class="description"> The web app was circulated throughout the RIT community so that people could submit the sounds that would be used as the building blocks for groups of participants at Imagine RIT to use to generate music. Afterwards the website served as the hub to host and download the music created at Imagine RIT.</p>
                </div>
                <div class="right chimeImg mImage"> <img alt="Chime Exhibt"  title="Chime Exhibit"  src="../assets/img/Chime2.svg"></div>
            </div>

        </section>
        <section class="Details">
            <div class="Links">
                <h1 class="Title">Projects Links</h1>
                <a href="https://github.com/A-Munoz/Chime" target="_blank">Chime Exhibit Github<img alt="Chime Exhibt" class="linkarrow" width="20px" height="20px" src="../assets/img/WhiteArrow.svg"></a>
               <a href="https://github.com/LaxLuker2/mysound" target="_blank">MySound Website Github<img alt="Chime Exhibt" class="linkarrow" width="20px" height="20px" src="../assets/img/WhiteArrow.svg"></a>
               <a href="https://mysound.cad.rit.edu/#/" target="_blank">MySound Website<img alt="Chime Exhibt" class="linkarrow" width="20px" height="20px" src="../assets/img/WhiteArrow.svg"></a>  
                <a href="https://designed.cad.rit.edu/nmcapstone/project/chime" target="_blank">More Info: Chime Website<img alt="Chime Exhibt" class="linkarrow" width="20px" height="20px" src="../assets/img/WhiteArrow.svg"></a> 
            </div>
        </section>

    </div>
</template>
<style scoped>

    .banner {
        background: url(../assets/img/ChimeBanner.jpg) no-repeat center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        background-position: top;
    }

    html {
        background: radial-gradient(78.3% 77.16% at 92.4% 97.56%, #F8F9FF 0%, #DBDDE3 100%);
        position: relative;
    }

    .videoPlayer {
        width: 80vw;
        max-width: 700px ;
        height: auto;
        background: linear-gradient(154.54deg, #2312ED 24.9%, #EB01FF 78.14%);
        margin: 0 auto;
        padding: 25px 20px 25px 25px;
        margin-top: 5vh;
    }

    .content img {
        object-position: center;
        min-width: 50vw;
        width: 100%;
        max-width: 100% ;
        overflow-x: hidden;
    }
    .iframeWrapper{
         position: relative;
         padding-bottom: 56.25%; /* 16:9 */
         height: 0;
    }
    .iframeWrapper iframe {
          position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
    }
    .Links a:link, a:active, a:hover, a:focus, a:visited{
    font-size: 1.3em;
    line-height: 1.6em;
    font-family: 'Open Sans', sans-serif;
    padding: 1.1em;
    text-decoration: none;
    max-width: 200px;
    color: #EBEEEE !important;
}
</style>
<script>
    "use strict"

    export default {
        name: 'Chime',
        props: {},
        components: {

        },

    }
</script>